import { axiosPublic, axiosPrivate } from "../utils";
import { toast } from 'react-toastify';

export const getAllLabMaterials = async (data) => {
    const { labId } = data;
    try {
        const res = await axiosPrivate.get('lab-material/all',{
            params: {
                labId: labId,
            }
        });
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }

        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}

export const createLabMaterial = async (data) => {
    const { labId, name, code, unit, description } = data;
    try {
        const res = await axiosPrivate.post('lab-material/create', {
            labId: labId,
            name: name,
            code: code,
            unit: unit,
            description: description,
        });
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }
        toast.success(res.data.message);

        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}

export const editLabMaterial = async (data) => {
    const { materialId, name, code, unit, description } = data;
    try {
        const res = await axiosPrivate.put(`lab-material/edit/${materialId}`, {
            name: name,
            code: code,
            unit: unit,
            description: description,
        });
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }
        toast.success(res.data.message);

        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}

export const viewLabMaterial = async (data) => {
    const { materialId } = data;
    try {
        const res = await axiosPrivate.get(`lab-material/${materialId}`);
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            return res.data.message;
        }

        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}